import React, { Fragment } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import LoginForm from "../../components/LoginForm/LoginForm";

const Login = () => {
  return (
    <Fragment>
      {/* <Contactpage /> */}
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="wpo-contact-title">
                <h2>Login</h2>
              </div>
              <div className="wpo-contact-form-area">
                <LoginForm />
              </div>
            </div>
          </div>
        </div>
        <section className="wpo-contact-map-section"></section>
      </section>
      <Scrollbar />
    </Fragment>
  );
};
export default Login;
